import z from 'zod';
import { AccordionSchema } from './Accordion';
import { AccordionItemSchema } from './AccordionItem';
import { ShapeLinkSchema } from './ShapeLink';
import { ShapeLinkGroupSchema } from './ShapeLinkGroup';
import { ButtonSchema } from './Button';
import { TextSchema } from './Text';
import { ImageSchema } from './Image';
import { VideoSchema } from './Video';
import { MediaSchema } from './Media';
import { ModalSchema } from './Modal';
import { ModalTextSchema } from './ModalText';
import { CarouselSchema } from './Carousel';
import { IconStackSchema } from './IconStack';
import { QuoteSchema } from './Quote';
import { NewsCardSchema } from './NewsCard';
import { NewsLatestPostsSchema } from './NewsLatestPosts';
import { NewsRunningLaneSchema } from './NewsRunningLane';
import { NewsSectionSchema } from './NewsSection';
import { CardSchema } from './Card';
import { PageGallerySchema } from './PageGallery';
import { PageHeroSchema } from './PageHero';
import { PageSectionSchema } from './PageSection';
import { PageFullWidthMediaSchema } from './PageFullWidthMedia';
import { BarSchema } from './Bar';
import { BarGroupSchema } from './BarGroup';
import { GlobeSchema } from './Globe';
import { MapSchema } from './Map';
import { PieSchema } from './Pie';
import { StackedBarSchema } from './StackedBar';
import { StackedBarGroupSchema } from './StackedBarGroup';
import { TreemapSchema } from './Treemap';
import { VanityNumberSchema } from './VanityNumber';
import { DatawrapperChartSchema } from './DatawrapperChart';
import { GithubButtonsSchema } from './GithubButtons';

export const SanityComponentUnion = z.discriminatedUnion('_type', [
  AccordionSchema,
  AccordionItemSchema,
  CardSchema,
  ShapeLinkSchema,
  ShapeLinkGroupSchema,
  ButtonSchema,
  GithubButtonsSchema,
  TextSchema,
  ModalSchema,
  ModalTextSchema,
  ImageSchema,
  VideoSchema,
  MediaSchema,
  CarouselSchema,
  IconStackSchema,
  QuoteSchema,
  VanityNumberSchema,
  NewsCardSchema,
  NewsLatestPostsSchema,
  NewsRunningLaneSchema,
  NewsSectionSchema,
  PageGallerySchema,
  PageHeroSchema,
  PageSectionSchema,
  PageFullWidthMediaSchema,
  BarSchema,
  BarGroupSchema,
  GlobeSchema,
  MapSchema,
  PieSchema,
  StackedBarSchema,
  StackedBarGroupSchema,
  TreemapSchema,
  DatawrapperChartSchema
]);

export type SanityComponent = z.infer<typeof SanityComponentUnion>;

export * from './Accordion';
export * from './AccordionItem';
export * from './ShapeLink';
export * from './ShapeLinkGroup';
export * from './Button';
export * from './GithubButtons';
export * from './NewsCard';
export * from './NewsLatestPosts';
export * from './NewsRunningLane';
export * from './NewsSection';
export * from './Text';
export * from './Modal';
export * from './ModalText';
export * from './Image';
export * from './Media';
export * from './Video';
export * from './Carousel';
export * from './IconStack';
export * from './Card';
export * from './PageGallery';
export * from './PageHero';
export * from './PageSection';
export * from './PageFullWidthMedia';
export * from './Chart';
export * from './Bar';
export * from './BarGroup';
export * from './Globe';
export * from './Map';
export * from './Pie';
export * from './StackedBar';
export * from './StackedBarGroup';
export * from './Treemap';
export * from './DatawrapperChart';
export * from './Quote';
export * from './VanityNumber';
